module.exports = __webpack_public_path__ + "static/kiaransalee-symbol-DND3_FnP-0e44f22ad48320c033c48cc8ace65b5e.jpg";